import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { ErrorPage } from 'cpie-common';
import { fetchForbiddenErrorPage } from './ForbiddenErrorPageSlice';
import { ForbiddenErrorPageContentSelector } from './ForbiddenErrorPageContentSelector';

export function useForbiddenErrorPage(): AbstractContentState<ErrorPage> {
    return useCmsContent(fetchForbiddenErrorPage, ForbiddenErrorPageContentSelector);
}
